export const initState = {
	$info: null,
	_info: 'init',

	productList: [],
	visibleProductList: [],
};

export default initState;
